module.exports = __webpack_public_path__ + "img/talentmanage.6c547a3e.svg";